import FileUpload from 'components/FileUpload';
import * as React from 'react';

const EXTENSIONS = ['csv', 'xlsx', 'xls', 'xlsm'];
const MAX_SIZE = 1024 * 1024 * 100;

interface Props {
  onFileSelected: (files: File[]) => void;
  disabled?: boolean;
}

export const UploadForm: React.FC<Props> = (props) => {
  const { onFileSelected, disabled } = props;
  return (
    <div
      className={`grow basis-1 space-y-2 flex flex-col text-dark ${disabled && '!text-gray-600'}`}
    >
      <p className={`font-medium text-${disabled ? 'gray-400' : 'dark'}`}>
        Upload a CSV, XLSX, XLS or XLSM file
      </p>
      <FileUpload
        fileExtensions={EXTENSIONS}
        maxSize={MAX_SIZE}
        onFileSelected={onFileSelected}
        disabled={disabled}
        className="grow-0 min-h-[192px]"
      />
    </div>
  );
};
UploadForm.displayName = 'AddContainers.UploadForm';
